import { useState } from "react";
import SupplierSearch from "./components/SupplierSearch";
import IntakeForm from "./components/IntakeForm";
import TrackerList from "./components/TrackerList";

type Tab = "intake" | "suppliers" | "tracker";

const TABS: { id: Tab; label: string; description: string }[] = [
  {
    id: "intake",
    label: "Intake",
    description: "Paste an email or notes. Claude extracts the fields.",
  },
  {
    id: "suppliers",
    label: "Supplier search",
    description: "Smart fuzzy match that deduplicates name variants.",
  },
  {
    id: "tracker",
    label: "Tracker",
    description: "All submitted requests in one view.",
  },
];

export default function App() {
  const [tab, setTab] = useState<Tab>("intake");

  return (
    <div className="min-h-screen">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-6 py-5">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-3">
                <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-thread-600 text-white font-semibold">
                  C
                </div>
                <div>
                  <h1 className="text-lg font-semibold text-slate-900">
                    Clotho
                  </h1>
                  <p className="text-xs text-slate-500">
                    AI-powered procurement intake · demo build
                  </p>
                </div>
              </div>
            </div>
            <a
              href="https://github.com/bippal"
              target="_blank"
              rel="noreferrer"
              className="text-xs text-slate-500 hover:text-slate-700"
            >
              github.com/bippal
            </a>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-8">
        <nav className="mb-8 flex flex-col gap-1 sm:flex-row sm:gap-2">
          {TABS.map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`flex-1 rounded-xl border px-4 py-3 text-left transition ${
                tab === t.id
                  ? "border-thread-500 bg-thread-50"
                  : "border-slate-200 bg-white hover:border-slate-300"
              }`}
            >
              <div
                className={`text-sm font-semibold ${
                  tab === t.id ? "text-thread-700" : "text-slate-900"
                }`}
              >
                {t.label}
              </div>
              <div className="mt-0.5 text-xs text-slate-500">
                {t.description}
              </div>
            </button>
          ))}
        </nav>

        <section>
          {tab === "intake" && <IntakeForm />}
          {tab === "suppliers" && <SupplierSearch />}
          {tab === "tracker" && <TrackerList />}
        </section>
      </main>

      <footer className="mt-16 border-t border-slate-200 bg-white py-8">
        <div className="mx-auto max-w-6xl px-6 text-center text-xs text-slate-500">
          Clotho — a portfolio demo built by Robert (Bip) Sutton ·{" "}
          <a
            href="mailto:bippal@gmail.com"
            className="text-thread-600 hover:underline"
          >
            bippal@gmail.com
          </a>
          <div className="mt-1">
            All data shown is synthetic. No real company information is used in
            this demo.
          </div>
        </div>
      </footer>
    </div>
  );
}
